export enum DeepLinkSource {
  OLD_COM = 'old-com',
  EMAIL = 'email',
  FCOM = 'fcom',
}
